module.exports = __webpack_public_path__ + "img/07.c52177a5.png";